import * as React from 'react'
import { toast } from 'sonner'
import { useDashboardStore } from '@/store/dashboardStore'
import type { SortingState } from '@tanstack/react-table'

// `sorting` retained for backward compat with Dashboard.tsx — adding a view
// is now handled by the "Save view" button inside FilterRail.
interface SavedViewChipsProps {
  sorting?: SortingState
}

export function SavedViewChips(_props: SavedViewChipsProps) {
  const { savedViews, activeViewName, applyView, deleteView } = useDashboardStore()

  function handleDelete(name: string, e: React.MouseEvent) {
    e.stopPropagation()
    toast(`Delete view "${name}"?`, {
      action: {
        label: 'Delete',
        onClick: () => deleteView(name),
      },
    })
  }

  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {savedViews.map((view) => (
        <button
          key={view.name}
          type="button"
          onClick={() => applyView(view.name)}
          className={`dash-viewchip${activeViewName === view.name ? ' active' : ''}`}
          aria-pressed={activeViewName === view.name}
        >
          {view.name}
          <span
            role="button"
            aria-label={`Delete view ${view.name}`}
            onClick={(e) => handleDelete(view.name, e)}
            style={{ color: 'var(--mute)', marginLeft: 2, fontSize: 11 }}
          >
            ×
          </span>
        </button>
      ))}

    </div>
  )
}
